export default __webpack_public_path__ + "static/media/access_your_skills.f2530f79.jpg";